/**
 * Merch listing filters and product-page size selection.
 *
 * Progressive enhancement throughout: with JavaScript disabled the listing
 * shows every product and the product page still posts a checked size to
 * /cart/add. This only adds filtering and the live price swap.
 */

(function () {
  "use strict";

  /* ---- Listing filters ---- */

  var grid = document.querySelector("[data-merch-grid]");
  if (grid) {
    var chips = [].slice.call(document.querySelectorAll("[data-merch-filter]"));
    var cards = [].slice.call(grid.querySelectorAll("[data-merch-card]"));
    var countEl = document.querySelector("[data-merch-count]");
    var emptyEl = document.querySelector("[data-merch-empty]");

    function apply(key) {
      var shown = 0;
      cards.forEach(function (c) {
        var match = key === "all" || c.dataset.group === key;
        c.hidden = !match;
        if (match) shown++;
      });
      chips.forEach(function (c) {
        c.setAttribute("aria-pressed", c.dataset.merchFilter === key ? "true" : "false");
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? " item" : " items");
      if (emptyEl) emptyEl.hidden = shown !== 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () { apply(chip.dataset.merchFilter); });
    });
  }

  /* ---- Product gallery ---- */

  /* Deliberately ABOVE the size-selector early returns below. Vinyl and CD are
     single-variant, so they never reach that code — and they have galleries
     too. Putting this after the returns would silently kill the gallery on
     exactly the products with the widest images. */

  var thumbs = document.querySelector("[data-merch-thumbs]");
  var mainImg = document.querySelector("[data-merch-main]");
  if (thumbs && mainImg) {
    var links = [].slice.call(thumbs.querySelectorAll(".mpdp__thumb"));

    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        var full = link.dataset.full;
        if (!full) return; /* no swap target — let the href do its job */
        event.preventDefault();
        mainImg.src = full;
        links.forEach(function (l) { l.classList.toggle("is-active", l === link); });
      });
    });
  }

  /* ---- Product page ---- */

  var form = document.querySelector("[data-merch-form]");
  if (!form) return;

  var sizes = [].slice.call(form.querySelectorAll("[data-merch-variant]"));
  var priceEl = document.querySelector("[data-merch-price]");
  var cta = form.querySelector(".mpdp__cta");
  if (!sizes.length) return;

  function sync() {
    var picked = sizes.filter(function (s) { return s.checked; })[0];
    if (!picked) return;

    /* data-price is already a formatted money string from Liquid, so nothing
       here has to guess at currency formatting. */
    if (priceEl && picked.dataset.price) priceEl.textContent = picked.dataset.price;
    if (cta) {
      cta.disabled = picked.disabled;
      cta.textContent = picked.disabled ? "Sold out" : "Add to cart";
    }
  }

  sizes.forEach(function (s) { s.addEventListener("change", sync); });
  sync();
})();
